import { APIFactory } from '../../ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from '../../ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import {
  IConversationContactData,
  IConversationContactResponse,
  IConversationContactsQuery,
} from '../../types/conversations/IConversationContact';
import { eContactType } from '../../types/conversations/eContactType';

const contactUrlByType = (contactType: eContactType) =>
  ({
    [eContactType.Person]: 'persons',
    [eContactType.Signatory]: 'signatories',
    [eContactType.ClientContact]: 'client_contacts',
    [eContactType.LenderContact]: 'lender_contacts',
    [eContactType.ThirdPartyContact]: 'third_party_contacts',
    [eContactType.None]: 'none',
  })[contactType];

export const getConversationContactsAsync = async ({
  orderId,
  contactType,
}: IConversationContactsQuery): Promise<IConversationContactData[]> => {
  return APIFactory(baseUrlService.ApiLocation)
    .get<IConversationContactResponse[]>(`/timber/api/internal/orders/${orderId}/${contactUrlByType(contactType)}`)
    .then((response) => response.data)
    .catch(axiosErrorHandler);
};
